import { render, staticRenderFns } from "./UPEITitration.vue?vue&type=template&id=45348902&"
import script from "./UPEITitration.vue?vue&type=script&lang=js&"
export * from "./UPEITitration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports